import { createHashRouter } from "react-router-dom";
import Layout from "./components/Layout";
import Home from "./components/Home";
import Courses from "./components/Courses";
import AboutUs from "./components/AboutUs";
import Contact from "./components/Contact";

const router = createHashRouter([
  {
    path: "/",
    element: <Layout />,
    children: [
      { index: true, element: <Home /> },
      { path: "courses", element: <Courses /> },
      { path: "about", element: <AboutUs /> },
      { path: "contact", element: <Contact /> },
    ],
  },
]);

export default router;
